/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

export class Colors {
/**
 * facebook color
 */
  static portage = "#8f79ed";
  // twitter
  static seagull = "#79c8ed";
  
  static deep_blush = "#dd6d9a";
  
  static sunglo = "#e66262";
  
  static boulder = "#777777";
  
  static pale_sky = "#6C757D";
  
  static white = "#ffffff";
  
  static black = "#000000";
  
  static ecstasy = "#fd7e14";
  
  static dove_gray = "#666666";
  
  static mine_shaft = "#333333";
  
  static gallery = "#eeeeee";
  
  static gallery_solid = "#efefef";
  
  static amber = "#ffc107";
  // facebook
  static chambray = "#3b5998";
  // instagram 
  static cerise = "#e83e8c";
  // youtube
  static punch = "#dc3545";
  // linkedin
  static science_blue = "#0A66C2";
  // discord
  static chetwode_blue = "#7289da";
  // slack
  static fuel_yellow = "#ECB22E";
  // whatsapp
  static deep_sea_green = "#075E54"
  // pin
  static monza = "#E60023";
  
  static nobel = "#B5B5B5";
  
  static fallow = "#cc9966";
  
  static outer_space = "#343a40";
  
  static silver = "#cccccc";
  
  static alabaster = "#fafafa";
  
  static dusty_gray = "#999999";
  
  static concrete = "#f2f2f2";
  
  static gray = "#808080";
  
  static apricot = "#ef837b";
  
  static limed_spruce = "#37474F";
  
  static cyan_blue = "#343a40";
}
